<script lang="ts">
    import type { ColorVariation } from '@shared/types/types';

    interface Props {
        colors?: ColorVariation[];
    }

    let { colors }: Props = $props();

    const MAX_SHOWN_COLORS = 5;

    const totalNumberOfColors = $derived(colors?.length || 0);
    const shown = $derived(colors?.slice(0, MAX_SHOWN_COLORS));
    const additional = $derived(colors?.slice(MAX_SHOWN_COLORS));
</script>

{#if colors && totalNumberOfColors > 1}
    <ul class="reptile-color-thumbs">
        {#each shown as [_, color], i (color.name)}
            <li
                style:background-color={color.hexCode ? `#${color.hexCode}` : undefined}
                style:z-index={colors.length - i}
                class={['reptile-color-thumbs__thumb', !color.hexCode ? color.baseColor || 'weiss' : '']}
            >
                <span class="oc-visually-hidden">{color.name}</span>
            </li>
        {/each}
        {#if additional?.length}
            <li class="reptile-color-thumbs__additional-colors">
                <span class="oc-visually-hidden">weitere Farben: </span>+{additional.length}
            </li>
        {/if}
    </ul>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-color-thumbs {
        /*                                                                                                                                                       */
        isolation: isolate;
        display: flex;
        align-items: center;

        &__thumb {
            width: tokens.$oc-base-dimension-absolute-16;
            height: tokens.$oc-base-dimension-absolute-16;
            border-radius: 50%;

            /*                                                                                                                                                                       */

            /*                                                                                                                                                                                                                                                                                               */
            outline: tokens.$oc-semantic-border-width-100 solid tokens.$oc-base-color-gray-150;

            @include mixins.base-color-swatch;

            &:not(:first-child) {
                /*                                                                    */
                margin-left: -5px;
            }
        }

        &__additional-colors {
            margin-left: tokens.$oc-semantic-spacing-absolute-25;
            font-size: tokens.$oc-base-font-size-75;
            line-height: tokens.$oc-base-font-line-height-100;
        }
    }
</style>
